<div class="input-group sensitive {{ classes }}" [ngClass]="{ 'input-icon': icons }">
    <span class="icon {{ icons }}"></span>
    <input
        appInputTrimmer
        [type]="type"
        class="sensitive-input"
        [name]="inputId"
        [id]="inputId"
        [value]="value"
        (input)="onInput()"
        (blur)="markAsTouched()"
        [placeholder]="placeholder | translate"
        [formControl]="inputControl"
        [readOnly]="readOnly || disabled || !isEdit"
        [maxLength]="maxLength"
        [ngClass]="{ 'invalid-control': !isValid && touched && !disabled, 'read-only': readOnly || disabled, 'is-not-editable': !isEdit }"
    />
    <button class="btn btn--secondary sensitive-data-button" (click)="enableEdit()" *ngIf="!isEdit">
        {{ 'REPERTOIRE.FORMS.SETTINGS.SCHOOL.MODIFY_STRIPE_KEY' | translate }}
    </button>
</div>
<div class="errors">
    <ng-content></ng-content>
</div>
